module.exports = __webpack_public_path__ + "img/3.852e11c9.png";